<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <gestao-terminal />
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

import GestaoTerminal from '../../components/patio/GestaoTerminal/GestaoTerminal.vue'

export default {
  data() {
    return {
      page: {
        title: 'Gestão de terminais',
      },
      breadcrumbs: [
        {
          text: 'Pátios',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Gestão de terminais',
          disabled: false,
        },
      ],
    }
  },
  components: {
    GestaoTerminal
  },
  methods: {
  }
}
</script>